import React, { forwardRef, useCallback, useEffect, useRef, useState } from 'react';
// material
import CloseIcon from '@material-ui/icons/Close';
import {
  Slide,
  Dialog,
  AppBar,
  Toolbar,
  Typography,
} from '@material-ui/core';
//
import ViewOfficialRequest from 'src/pages/dashboard/ViewQuotation';

const Transition = forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);
 function FullScreenDialogEstimate({
  open,
   setOpen,
   projectId:initialProjectId,
   projectName:initialProjectName,
   isEditEstimate:initialIsEditEstimate,
   setRenderCards,
   renderCards,
   setIsEditEstimate:EditEstimate,
   projectEstimate,isOpenModal,setIsOpenModal,handleOpenViewEstimate
  }) {

  const [dataChanged, setDataChanged] = useState(false); 
  const childRef = useRef(null);
  const [saveTrigger, setSaveTrigger] = useState(false);

  const headerStepBackRef = useRef(() => false);

  // create state for heading change
const [heading, setHeading] = useState("")

  // const [openEdit, setOpenEdit] = useState(false)
// const[jobCostId,setJobCostId]=useState('');
const [projectId, setProjectId] = useState(
  localStorage.getItem('estimateProjectId') || initialProjectId || ''
);
const [projectName, setProjectName] = useState(
  localStorage.getItem('estimateProjectName') || initialProjectName || ''
);
const [isEditEstimate, setIsEditEstimate] = useState(
  localStorage.getItem('isEditEstimate') === 'true' || initialIsEditEstimate || false
);

  const handleExitEstimateEditMode = useCallback(() => {
    setIsEditEstimate(false);
    localStorage.setItem('isEditEstimate', 'false');
  }, []);

useEffect(() => {
  if (open) {
    localStorage.setItem('estimateProjectId', projectId);
    localStorage.setItem('estimateProjectName', projectName);
    localStorage.setItem('isEditEstimate', isEditEstimate);
    localStorage.setItem('estimateOpenProductionPopup', 'true');
  } else {
    // localStorage.removeItem('estimateProjectId');
    // localStorage.removeItem('estimateProjectName');
    // localStorage.removeItem('isEditEstimate');
    localStorage.removeItem('estimateOpenProductionPopup',);
  }
}, [open, projectId, projectName, isEditEstimate]);
useEffect(() => {
  if (open) {
    setProjectId(localStorage.getItem('estimateProjectId') || initialProjectId || '');
    setProjectName(localStorage.getItem('estimateProjectName') || initialProjectName || '');
    setIsEditEstimate(localStorage.getItem('isEditEstimate') === 'true' || initialIsEditEstimate || false);
  }
}, [open]);

   const handleClose = () => {
    // No auto-save on close – only "Save as Draft" button saves. Just close.
    closeAfterSave();
  };

   const closeAfterSave = () => {
     setProjectId("");
     setProjectName("");
     setIsEditEstimate("");
     // Always reset edit state so the next open starts on the detail view
    //  setOpenEdit(false);
     setDataChanged(false);
     setSaveTrigger(false);
     setOpen(false);

     localStorage.removeItem('estimateProjectId');
     localStorage.removeItem('estimateProjectName');
     localStorage.removeItem('isEditEstimate');
     localStorage.removeItem('estimateOpenProductionPopup');

     setRenderCards((prev) => !prev);
   };

  const handleHeaderClose = () => {
    const tryStep = headerStepBackRef.current;
    if (typeof tryStep === 'function' && tryStep()) return;
    handleClose();
  };

  const handleDataChange = () => {
    setDataChanged(true); 
    console.log('Entered=handleDataChange')
  };
  return (
    <>
      <Dialog fullScreen open={open} onClose={handleHeaderClose} TransitionComponent={Transition}>
        <AppBar position="relative" mb={3}>
          <Toolbar>
            <Typography variant="h6" sx={{ flex: 1, ml: 2 }}>
              {heading || projectName}
            </Typography>
              <CloseIcon onClick={handleHeaderClose} sx={{fontSize:'2.7rem',cursor:'pointer'}}/>
          </Toolbar>
        </AppBar>
        <MemoizedViewOfficialRequest
          saveTrigger={saveTrigger}
          // openEdit={openEdit}
          // setOpenEdit={setOpenEdit}
          popupOn={true}
          closeAfterSave={closeAfterSave}
          childRef={childRef}
          setRenderCards={setRenderCards}
          idOfProject={projectId}
          isEditEstimate={isEditEstimate}
          headerStepBackRef={headerStepBackRef}
          onExitEstimateEditMode={handleExitEstimateEditMode}
          closeView={handleClose}
          renderCards={renderCards}
          onDataChange={handleDataChange} // Pass data change handler
          setIsEditEstimate={EditEstimate}
          projectEstimate={projectEstimate}
          isOpenModal={isOpenModal}
          setIsOpenModal={setIsOpenModal}
          handleOpenViewEstimate={handleOpenViewEstimate}
          heading={heading}
          setHeading={setHeading}

        />
      </Dialog>
    </>
  );
}
const MemoizedViewOfficialRequest = React.memo(ViewOfficialRequest);

export default React.memo(FullScreenDialogEstimate);